export default __webpack_public_path__ + "static/media/STL_GRC_Certificate_2.f0b21591.jpg";